import { NotifyHelper } from "../../../helpers/toast";
import { eTinhTrangNoMonActionsObj } from "../../action-types/tinh-trang-no-mon/ITinhTrangNoMonActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const tinhTrangNoMonActions = {
    ...generateActions(eTinhTrangNoMonActionsObj, "TINH_TRANG_NO_MON"),
    ...generateActionForKey(eTinhTrangNoMonActionsObj, "TINH_TRANG_NO_MON", "LOAD_ERROR", (m) => {
        NotifyHelper.Error(m);
    }),
}